﻿
export abstract class PWDates {
       
    public static getDateString(dateString: any) {
        let date = new Date(dateString);

        if (this.isValidDate(date)) {
            return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        }
        else {
            return dateString;
        }
    }

    public static getDateTimeString(dateString: any) {
        let date = new Date(dateString);

        if (this.isValidDate(date)) {
            return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ` +
                `${this.padDateValue(date.getHours())}:${this.padDateValue(date.getMinutes())}:${this.padDateValue(date.getSeconds())}`;
        }
        else {
            return dateString;
        }
    }

    public static getLocalDateString(dateString: any) {
        let date = new Date(dateString);

        if (this.isValidDate(date)) {
            //for Timezone issues       
            const offsetMs = date.getTimezoneOffset() * 60 * 1000;
            const dateLocal = new Date(date.getTime() - offsetMs);
            return `${dateLocal.getMonth() + 1}/${dateLocal.getDate()}/${dateLocal.getFullYear()}`;
        }
        else {
            return dateString;
        }
    }

    public static getLocalDateTimeString(dateString: any) {
        let date = new Date(dateString);

        if (this.isValidDate(date)) {
            //for Timezone issues       
            const offsetMs = date.getTimezoneOffset() * 60 * 1000;
            const dateLocal = new Date(date.getTime() - offsetMs);
            return `${dateLocal.getMonth() + 1}/${dateLocal.getDate()}/${dateLocal.getFullYear()} ` +
                `${this.padDateValue(dateLocal.getHours())}:${this.padDateValue(dateLocal.getMinutes())}:${this.padDateValue(dateLocal.getSeconds())}`;

        }
        else {
            return dateString;
        }
    }

    public static isPreviousDateMoreRecentThanDays(date: Date, days: number) {
        if (days && days > 0) {

            return date > this.addDaysToCurrentDate(-days);
        }
    }

    public static addDaysToCurrentDate = function (days: number) {
        const date = new Date();
        date.setDate(date.getDate() + days);
        return date;
    };

    public static getDifferenceInDays(earlyDate: Date, laterDate: Date) {
        const timeDifference = laterDate.getTime() - earlyDate.getTime();
        return timeDifference / (1000 * 3600 * 24);
    }

    private static padDateValue(n: number) { return n < 10 ? '0' + n : n }

    private static isValidDate(d: any) {
        return typeof (d === 'number') && d instanceof Date;
    }
}